var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm._m(0);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "statistic-tabs mt-5"
  }, [_c('div', {
    staticClass: "stat-block"
  }, [_c('div', {
    staticClass: "div-block-2"
  }, [_c('img', {
    staticClass: "tendency-icon",
    attrs: {
      "alt": "",
      "src": require("@/images/Vector-12.png"),
      "loading": "lazy"
    }
  }), _c('div', {
    staticClass: "text-small green--text"
  }, [_vm._v("+14.6%")])]), _c('div', {
    staticClass: "blacktext"
  }, [_vm._v("Nové hypotéky")]), _c('div', {
    staticClass: "large-text stat-number pop-800"
  }, [_vm._v("8")])]), _c('div', {
    staticClass: "stat-block"
  }, [_c('div', {
    staticClass: "div-block-2"
  }, [_c('img', {
    staticClass: "tendency-icon",
    attrs: {
      "alt": "",
      "src": require("@/images/Vector-12-red.png"),
      "loading": "lazy"
    }
  }), _c('div', {
    staticClass: "text-small red--text"
  }, [_vm._v("-25%")])]), _c('div', {
    staticClass: "black--text"
  }, [_vm._v("Načerpané")]), _c('div', {
    staticClass: "large-text stat-number pop-800"
  }, [_vm._v("589.000€")])])]);

}]

export { render, staticRenderFns }